import styled from "styled-components";

export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "220px",
	fontSize: "15px",
};

export const SwitchContainer = styled.div`
	margin-top: 28px;
`;